import type { PostingDiscoveryRow } from '@revelio/data-access';

type PostingDiscoveryColumn = keyof Omit<PostingDiscoveryRow, '__typename'>;

/** Row keys that should use numeric sort/compare on Posting Discovery. */
export const POSTING_DISCOVERY_NUMERIC_SORT_KEYS =
  new Set<PostingDiscoveryColumn>(['salary']);

export const POSTING_DISCOVERY_VALID_COLUMNS: PostingDiscoveryColumn[] = [
  'company_name',
  'jobtitle',
  'description',
  'salary',
  'seniority',
  'skills',
  'remote_type',
  'location',
  'region',
  'country',
  'state',
  'msa',
  'city',
  'post_date',
  'posting_url',
  'expected_hires',
] as const;

export const POSTINGS_DISCOVERY_DEFAULT_COLUMNS: PostingDiscoveryColumn[] = [
  'company_name',
  'jobtitle',
  // 'description',
  'salary',
  'seniority',
  'skills',
  'remote_type',
  'location',
];

// Returned by the query (kept in the network response) but hidden from the
// column picker, the rendered table, and the data export.
export const POSTING_DISCOVERY_HIDDEN_COLUMNS: PostingDiscoveryColumn[] = [
  'job_id',
  'rcid',
  'company_id',
  'role_v3_id',
  'rics_k10',
  'rics_k50',
  'rics_k400',
];

export const validatePostingsDiscoveryColumns = (
  columns: string[]
): string[] => {
  const validColumnSet = new Set(POSTING_DISCOVERY_VALID_COLUMNS);
  const hiddenColumnSet = new Set(POSTING_DISCOVERY_HIDDEN_COLUMNS);

  return columns.filter(
    (col) =>
      validColumnSet.has(col as PostingDiscoveryColumn) &&
      !hiddenColumnSet.has(col as PostingDiscoveryColumn)
  );
};
